import { DropdownContent } from '@anm/components/Dropdown';
import { TooltipContent } from '@anm/components/Tooltip';
import { flexCenter, flexRow, media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

const commonPseudoElementStyles = css`
  top: 50%;
  content: '';
  left: 50%;
  position: absolute;
  background: #292a2b;
  transform: translate(-50%, -50%);
`;

export const Button = styled.div`
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: relative;
  border-radius: 50%;
  background: #f5f7fa;
  box-sizing: border-box;
  border: 1px solid rgba(1, 83, 130, 0.2);
  &:after {
    width: 12px;
    height: 2px;
    ${commonPseudoElementStyles};
  }
  &:before {
    width: 2px;
    height: 12px;
    ${commonPseudoElementStyles};
  }
`;

export const Text = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
  margin: 0 0 0 16px;
  ${flexCenter};
  color: ${({ theme }) => theme.textColor};
`;

export const Row = styled.div`
  ${flexRow};
  cursor: pointer;
  ${TooltipContent} {
    left: 50%;
    top: -12px;
    color: #fff;
    padding: 8px;
    right: unset;
    font-size: 14px;
    min-width: 124px;
    transform: translate(-50%, -100%);
    &:before {
      left: 50%;
      border-width: 0 7px 7px 7px;
      transform: rotate(180deg) translateX(50%);
    }
  }
`;

export const ItemWrapper = styled(Row)`
  padding: 0 10px;
  &:hover {
    background: rgba(32, 171, 210, 0.1);
  }
`;

export const Wrapper = styled.div<{ isFullWidthDropdown?: boolean }>`
  position: relative;
  display: inline-flex;
  img {
    width: 32px;
  }
  ${DropdownContent} {
    top: 60px;
    left: 25px;
  }
  ${({ isFullWidthDropdown }) =>
    isFullWidthDropdown &&
    css`
      ${DropdownContent} {
        left: 0;
        width: 100%;
        transform: none;
        &:before,
        &:after {
          content: none;
        }
      }
    `};
`;

const mobileContentWrapper = media.phone`
  padding: 0;
`;

export const DropdownContentWrapper = styled.div`
  width: 100%;
  padding: 10px 0;

  ${mobileContentWrapper}
`;

export const DropdownItemText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.textColor};
  margin-left: 8px;
  line-height: 45px;
`;
